import type { ComponentType } from 'react';
import { Box, styled } from '@mui/material';
import type { BoxProps } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const StyledDataGridContainer: ComponentType<BoxProps> = styled(Box)({
  display: 'flex',
  flex: 1,
  minHeight: 0,
  height: '100%',
  maxHeight: '60vh',
  overflow: 'hidden',
  position: 'relative',
  minWidth: 0,
});

export const StyledDataGridPro = styled(DataGridPro)(({ theme }) => ({
  border: 'none',
  borderRadius: 0,
  '& .MuiDataGrid-cell': {
    borderTop: 'none',
    borderBottom: 'none',
  },
  '& .MuiDataGrid-main': {
    minHeight: '400px',
  },
  '& .MuiDataGrid-columnHeader ': {
    borderBottom: '1px solid var(--mui-palette-divider) !important',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 500,
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: 'none',
  },
  '& .MuiDataGrid-filler': {
    borderBottom: 'none !important',
  },
  '& .numeric-cell': {
    fontFamily: theme.typography.numeric?.fontFamily ?? theme.typography.fontFamily,
    fontVariantNumeric: 'tabular-nums',
  },
})) as typeof DataGridPro;

export const LeaderboardDataGridContainer: ComponentType<BoxProps> = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  '& .MuiDataGrid-root .MuiDataGrid-cell': {
    padding: '16px 8px',
    borderBottom: '1px solid var(--mui-palette-divider)',
  },
});

export const DATAGRID_CONSTANTS = {
  ROW_HEIGHT: 32,
  HEADER_HEIGHT: 44,
  BUFFER_PX: 100,
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 50,
    SIZE_OPTIONS: [25, 50, 100] as number[],
  },
} as const;
